import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({ 
  path, 
  themeMode = 'dark', 
  height = '20vh', 
  width = '20vh',
  style = {}
}) => {
  return (
    <img
      src={path}
      alt="icon"
      style={{
        height,
        width,
        ...style
      }}
    />
  );
};

Icon.propTypes = {
  path: PropTypes.string.isRequired,
  themeMode: PropTypes.oneOf(['dark', 'light']),
  height: PropTypes.string,
  width: PropTypes.string,
  style: PropTypes.object
};

export default Icon; 